export default __webpack_public_path__ + "static/media/5.ddd03b03.png";